import moment from 'moment';

export function formattedDate(value: string, formatString: string): string {

    return moment(value).format(formatString);

}